import { CircularProgress } from "@mui/material";

export default function LoadingOverlay() {
  return (
    <div className="loading-overlay-wrapper">
      <CircularProgress color="success" />
    </div>
  );
}
